module.exports = "/lucky-balls/img/weager/balls/normal/LB_6.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/balls/normal/LB_6.png
// module id = 1189
// module chunks = 0